const marqueeConfigs: { [key: string]: string[] } = {
  en: [
    "TSLA dropped to 180, I sold my house to go all in",
    "Elon soars bravely, forever followed by iMars",
    "Tesla never disappoints",
    "HOLD on to Tesla",
    "Counting on Tesla to double in a year",
    "Stacking up shares at every dip",
    "Tesla's ceiling? Outer space.",
    "All in on supporting Elon",
    "Leading the pack by miles",
    "Hitting the decade's rock-bottom",
    "With FSD, we'll be autopiloting Teslas on the moon",
    "Tearful top-ups",
    "Snagging Tesla stock under $200 is a steal",
  ],
  "zh-Hans": [
    "TSLA跌到180了，卖房All in了家人们",
    "老马勇敢飞，i马永相随",
    "特斯拉永远不会让我失望",
    "HOLD特斯拉",
    "1年后等待特斯拉翻倍",
    "跌了就是加仓加仓加仓",
    "特斯拉的顶是太空",
    "全力支持老马",
    "遥遥领先",
    "未来10年的最低点",
    "有了FSD将来上月球开特斯拉也能自动驾驶",
    "含泪加仓",
    "特斯拉200以下就是捡钱",
  ],
  "zh-Hant": [
    "TSLA跌到180了，賣房All in了家人們",
    "老馬勇敢飛，i馬永相隨",
    "特斯拉永遠不會讓我失望",
    "HOLD特斯拉",
    "1年後等待特斯拉翻倍",
    "跌了就是加倉加倉加倉",
    "特斯拉的頂是太空",
    "全力支持老馬",
    "遙遙領先",
    "未來10年的最低點",
    "有了FSD將來上月球開特斯拉也能自動駕駛",
    "含淚加倉",
    "特斯拉200以下就是撿錢",
  ],
  "zh-HK": [
    "Telsa跌到180啦，賣咗層樓All in啦",
    "老馬勇敢飛，i馬永相隨",
    "Telsa永遠唔會令我失望",
    "HOLD特斯拉",
    "1年後等翻特斯拉翻兩番",
    "跌咗就係加倉加倉加倉",
    "特斯拉嘅頂係太空",
    "全力撐老馬",
    "遙遙領先",
    "未來10年嘅最底點",
    "有咗FSD日後喺月球開特斯拉都可以自駕",
    "含淚加倉",
    "特斯拉200以下就係揾笨",
  ],
};

export default marqueeConfigs;
